module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/steve_thumb-1d1d7c7eae66b2394d254ae1013729cc.jpg";